<template>
  <div class="flex flex-col-reverse md:flex-row relative">
    <!-- Sección izquierda -->
    <div :class="[
      'bg-cover text-white gap-3 md:w-1/2 p-5 flex justify-center flex-col md:flex-row',
      currentMode.leftBackgroundMobile,
      currentMode.leftBackgroundDesktop
        ? `md:${currentMode.leftBackgroundDesktop}`
        : '',
    ]">
      <div class="flex md:flex-col md:mt-10 md:w-2/3 text-start px-5 relative">
        <div class="flex flex-col md:items-start items-center text-center md:w-full md:gap-5">
          <div class="">
            <p class="my-0 py-0 font-bold text-lg md:text-3xl">
              {{ currentMode.leftTitle1 }}
            </p>
            <p class="my-0 py-0 font-bold text-lg md:text-3xl">
              {{ currentMode.leftTitle2 }}
            </p>
          </div>
          <p class="md:w-3/4 md:text-left text-center">
            {{ currentMode.leftDescription }}
          </p>
        </div>

        <!-- Botón desktop para neumáticos -->
        <button v-if="currentMode.leftButtonText && modo_sistema === NEGOCIOS.NEUMATICOS" @click="scrollToTop"
          class="bg-white hidden text-center md:block text-ROJO_LEON rounded-md px-5 py-2 mt-3 font-bold w-1/2 hover:bg-VINO_LEON hover:text-white transition empecemos-btn">
          {{ currentMode.leftButtonText }}
        </button>

        <!-- Link desktop para baterías -->
        <NuxtLink v-if="currentMode.leftButtonText && modo_sistema === NEGOCIOS.BATERIAS" :to="currentMode.leftLink"
          class="bg-white hidden text-center md:block text-ROJO_LEON rounded-md px-5 py-2 mt-3 font-bold w-1/2 hover:bg-VINO_LEON hover:text-white transition empecemos-btn">
          {{ currentMode.leftButtonText }}
        </NuxtLink>
      </div>

      <!-- Botón mobile para neumáticos -->
      <button v-if="currentMode.leftButtonText && modo_sistema === NEGOCIOS.NEUMATICOS" @click="scrollToTop"
        class="md:hidden block bg-white text-center text-ROJO_LEON rounded-md px-5 py-1 my-3 font-bold w-2/3 mx-auto hover:bg-VINO_LEON hover:text-white transition empecemos-btn">
        {{ currentMode.leftButtonText }}
      </button>

      <!-- Link mobile para baterías -->
      <NuxtLink v-if="currentMode.leftButtonText && modo_sistema === NEGOCIOS.BATERIAS" :to="currentMode.leftLink"
        class="md:hidden block bg-white text-center text-ROJO_LEON rounded-md px-5 py-1 my-3 font-bold w-2/3 mx-auto hover:bg-VINO_LEON hover:text-white transition empecemos-btn">
        {{ currentMode.leftButtonText }}
      </NuxtLink>
    </div>

    <!-- Sección derecha -->
    <div :class="[
      'bg-cover md:w-1/2 p-5 flex justify-center flex-col md:flex-row',
      currentMode.rightBackgroundMobile,
      currentMode.rightBackgroundDesktop
        ? `md:${currentMode.rightBackgroundDesktop}`
        : '',
    ]">
      <div class="flex flex-col md:mt-10 md:w-2/3 text-center md:text-start px-5 relative">
        <div class="flex flex-col w-full md:gap-5">
          <div>
            <p class="my-0 py-0 font-bold text-lg md:text-3xl"
              :class="modo_sistema === NEGOCIOS.NEUMATICOS ? 'text-ROJO_LEON' : 'text-white'">
              {{ currentMode.rightTitle1 }}
            </p>
            <p class="my-0 py-0 font-bold text-lg md:text-3xl"
              :class="modo_sistema === NEGOCIOS.NEUMATICOS ? 'text-ROJO_LEON' : 'text-white'">
              {{ currentMode.rightTitle2 }}
            </p>
          </div>
          <p class="font-semibold mt-3" :class="modo_sistema === NEGOCIOS.NEUMATICOS ? 'text-black' : 'text-white'">
            {{ currentMode.rightDescription }}
          </p>
        </div>
        <NuxtLink v-if="currentMode.rightLink && currentMode.rightLinkText" :to="currentMode.rightLink" :class="[
          'font-bold py-2 my-10 w-1/2 transition mx-auto md:mx-0 text-center rounded-md',
          modo_sistema === NEGOCIOS.NEUMATICOS
            ? 'bg-ROJO_LEON text-white hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 hover:text-ROJO_LEON mb-[60px]'
            : 'bg-white text-ROJO_LEON hover:bg-VINO_LEON hover:text-white ',
        ]">
          {{ currentMode.rightLinkText }}
        </NuxtLink>
      </div>
    </div>

    <!-- Imagen león -->
    <img v-if="modo_sistema === NEGOCIOS.NEUMATICOS"
      class="hidden md:block absolute z-[50] left-1/2 -translate-x-1/2 hover:scale-100 transition scale-90"
      :src="'/img/home/home-leon-mobile.webp'" alt="León" />
  </div>
</template>

<script setup>
import { NEGOCIOS } from "~/constants/negocios";

const modo_sistema = useState('modo_sistema');

const props = defineProps({
  // Aquí puedes agregar props específicas si las necesitas
});

const modes = {
  baterias: {
    leftBackgroundMobile: "bg-home-banner-bg-5-2-mobile",
    leftBackgroundDesktop: "bg-home-banner-bg-5-2-desktop",
    leftTitle1: "Reserva de Capacidad (RC)",
    leftTitle2: "y Ampere-Hora (AH)",
    leftDescription: "Las baterías de automóviles son componentes esenciales para el funcionamiento de los vehículos, y entender conceptos como la Reserva de Capacidad (RC) y los Ampere-Hora (AH) es fundamental para mantener su rendimiento óptimo.",
    leftButtonText: "Aprender más",
    leftLink: `/${NEGOCIOS.BATERIAS}/concepts`,
    rightBackgroundMobile: "bg-home-banner-bg-4-2-mobile-battery",
    rightBackgroundDesktop: "bg-home-banner-bg-4-2-desktop-battery",
    rightTitle1: "Mantenimiento preventivo",
    rightTitle2: "de baterías",
    rightDescription: "Las baterías son componentes críticos en los vehículos, y un mantenimiento adecuado puede extender significativamente su vida útil. Aquí hay consejos para un mantenimiento preventivo eficaz.",
    rightLink: `/${NEGOCIOS.BATERIAS}/mantenimiento`,
    rightLinkText: "Ver Consejos",
  },

  neumaticos: {
    leftBackgroundMobile: "bg-home-banner-bg-5-2-mobile",
    leftBackgroundDesktop: "bg-home-banner-bg-5-2-desktop",
    leftTitle1: "¿AÚN NO SABES QUÉ",
    leftTitle2: "NEUMÁTICOS NECESITAS?",
    leftDescription: "Responde unas pocas preguntas y te ayudaremos a decidir el neumático más adecuado para ti.",
    leftButtonText: "Empecemos",
    rightBackgroundMobile: "bg-home-banner-bg-5-1-mobile",
    rightBackgroundDesktop: "bg-home-banner-bg-5-1-desktop",
    rightTitle1: "CONSEJOS PARA EL CUIDADO",
    rightTitle2: "DE TUS NEUMÁTICOS",
    rightDescription: "¿Quieres sacar el máximo partido a tus neumáticos? Cuídalos y optimizarás el consumo de combustible y mejorará la conducción y rendimiento. Puedes acudir a cualquiera de nuestros locales.",
    rightLink: `/${NEGOCIOS.NEUMATICOS}/tips`,
    rightLinkText: "Ver Consejos",
  },
};

const currentMode = computed(() => modes[modo_sistema.value] || {});

const scrollToTop = () => {
  window.scrollTo({
    top: 140,
    behavior: "smooth",
  });
};
</script>